<template>
  <HScaffold title="实用工具下载">
    <div class="tProfileParentDiv">
      <div :style="{
        display: 'flex',
        flexDirection: 'column',
        alignItems:'center',
      }">
        <div :style="hcf.getTextStyle({
          color:'#999',addSize:-2,marginTop:5,marginBottom:5,
        })">
          以下应用均已通过官方验证，保证安全无毒，请您放心下载
        </div>
        <div v-for="(item,index) in itemList" :key="index"
             class="tEachItemDiv" @click="jumpDownUrl(item['DownloadUrl'])">
          <div v-if="item.Icon && item.Icon !== ''"
               style="align-items: center;justify-content: center;display:flex;margin-right: 10px;">
            <HCacheImage :src="item.Icon" height="20px" alt=""/>
          </div>
          <div :style="hcf.getTextStyle({
            fontWeight:'bold'})">
            {{ item.Name }}
          </div>
          <div style="display: flex;flex:1"/>
          <div :style="{
            backgroundColor:hcf.getMainColor(),
            padding:'5px 10px',
            borderRadius:'30px',
          }">
            <div :style="hcf.getTextStyle({
              color:'#fff',addSize:-2
            })">
              立即下载
            </div>
          </div>
        </div>
      </div>
    </div>
  </HScaffold>

</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  let useUser = useUserStore();
  let useHttp = useHHttp();
  let useComApi = useHComApi();
  const itemList = ref(false);

  useHttp.request("/app/tools/list", (data) => {
    itemList.value = data["List"];
  }).then(r => {
  });

  function jumpDownUrl(url){
    if(hdi.isRunDesktop && HNewGameUIConfig.newGameUIType === 3){
      window.parent?.postMessage(`${url}|mgpay`, "*"); // "*" 表示允许任意来源接收
    }else{
      hcf.launchUrl(url);
    }
  }

</script>


<style scoped>

  .tProfileParentDiv {
    display: flex;
    flex-direction: column;
  }

  .tEachItemDiv {
    border-radius: 5px;
    margin: 5px;
    padding: 10px;
    width: calc(100% - 20px);
    background-color: var(--ct-main-container-bg-color);
    display: flex;
    flex-direction: row;
    align-items: center;
  }

</style>
